import React, {useState, useContext} from 'react';
import { toast } from 'react-toastify';
import { withRouter, useHistory } from 'react-router-dom';
import config from './../../services/config.json';
import SimpleContext from './../context/SimpleContext';
import { browserName, mobileVendor, deviceType } from 'react-device-detect';
import axios from 'axios';

const SecondRegister = () => {

    const context = useContext(SimpleContext);

    const history = useHistory();

    const [verificationCode, setverificationCode] = useState([]);
    const [fullname, setfullname] = useState();


    const versionInfo = {
        method: 'POST',
        headers: { 
            'content-type': 'application/x-www-form-urlencoded'
        },
        data: {
            Num: context.UseInFo.mobile,
            Version: "1000",
            VersionName: "react",
            SDate: context.FullDate.Date,
            STime: context.FullDate.time,
            Moaref: "",
            AndroidVersion: "1000",
            CellPhoneModel: `${mobileVendor}`+","+`${browserName}`+","+`${deviceType}`
        },
        url:`${config.InsertCustVersion}`,
    }

    axios(versionInfo).then(response =>
        {
 
        }
    )
    .catch(er => {
        console.log(er);
    })

    const reset = () => {
        setverificationCode("");
    };

    const wrongNumber = () =>{
        localStorage.clear()
        window.location.reload()
    }

    const handleSubmit = () =>{
        String.prototype.toEnglishDigit = function() { 
            var find = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']; 
            var replace = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']; 
            var replaceString = this; 
            var regex; 
            for (var i = 0; i < find.length; i++) { 
                regex = new RegExp(find[i], "g"); 
                replaceString = replaceString.replace(regex, replace[i]);
            } 
            return replaceString; 
        };
       
        try{
            if (verificationCode.toEnglishDigit() === context.verCode){
                context.setIsLoggedIn(true)
                toast.success("خوش آمدید",{
                    position:"top-center",
                    closeOnClick: true
                });
                history.replace("/")
            }else{
                toast.error("کد احراز هویت صحیح نمیباشد.",{position:"top-right", closeOnClick:true});
                reset();
            }
            
        }catch(ex) {
            console.log(ex);
            toast.error("مشکلی پیش آمده.",{position:"top-right", closeOnClick:true});
        }
    };  
    return (
        <div className="main">
            <div className="mainSecondReg">
                <div style={{width:"70%", height:"100%"}}>
                    <div style={{marginBottom: "20%",display: 'flex', justifyContent:"center"}}>
                        <img className="regimg" src="./images/animated_splash.gif" alt="ApiLogo" />
                    </div>
                    <div style={{
                            width: '100%',
                            height: 'auto',
                            flexDirection:"column",
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginTop:'100px'
                        }}>
                        <input
                            autoComplete="off"
                            type="text"
                            name="verificationCode"
                            style={{
                                fontSize: '12px',
                                borderRadius: '9px',
                                textAlign:'center',
                                marginBottom:'5%',
                                maxWidth:"263px",
                                width:"100%",
                                height:"35px",
                                boxShadow: 'rgb(99 99 99 / 20%) 0px 2px 8px 0px',
                                border:"1px solid lightgray"

                            }}
                            placeholder="کد فعالسازی"
                            aria-describedby="username"
                            value={verificationCode}
                            onChange={ph => {
                                setverificationCode(ph.target.value);
                            }}
                        />
                    
                            <input
                                type="text"
                                style={{
                                    fontSize: '12px',
                                    borderRadius: '9px',
                                    textAlign:'center',
                                    marginBottom:'5%',
                                    maxWidth:"263px",
                                    width:"100%",
                                    height:"35px",
                                    boxShadow: 'rgb(99 99 99 / 20%) 0px 2px 8px 0px',
                                    border:"1px solid lightgray"
    
                                }}
                                placeholder="معرف"
                                aria-describedby="username"
                                value={fullname}
                                onChange={e => setfullname(e.target.value)} 
                            />
                            {
                                verificationCode.length < 4?
                                <button style={{
                                    height:'35px',
                                    backgroundColor: '#e5e5e5',
                                    width:"100%",
                                    maxWidth:"260px",
                                    border: 'none',
                                    borderRadius: '12px',
                                    color: '#fff',
                                    fontSize: '15px'
                                }}>
                                    ورود
                                </button>
                                :

                                <button style={{
                                    height:'35px',
                                    backgroundColor: '#28a745',
                                    width:"100%",
                                    maxWidth:"260px",
                                    border: 'none',
                                    borderRadius: '12px',
                                    color: '#fff',
                                    fontSize: '15px'
                                }} onClick={()=>handleSubmit()}>
                                    ورود
                                </button>
                            }
                            
                            <button style={{
                                height:'35px',
                                backgroundColor: '#f77f25',
                                width:"100%",
                                maxWidth:"260px",
                                border: 'none',
                                borderRadius: '12px',
                                color: '#fff',
                                fontSize: '15px',
                                marginTop:"3%"
                            }}
                            onClick={wrongNumber}
                            >تغیر شماره موبایل</button>
                    </div>   
                </div>
            </div>
        </div> 
            
     );
}
 
export default withRouter(SecondRegister);